
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import FiscalPeriodsContent from "./components/FiscalPeriodsContent.vue";

export default defineComponent({
  name: "FiscalPeriodsPage",
  components: {
    BreadCrumb,
    FiscalPeriodsContent,
  },
});
